import { LocationNumbersService } from '../../../services'

const editPhoneNumber = async function ({ commit, dispatch, state }, config) {
  const { locationId, payload, action } = config
  try {
    if (!payload?.number) {
      throw new Error('No number passed to edit configuration!')
    }
    const data = await LocationNumbersService.updatePhoneNumber(locationId, payload)
    await dispatch('fetchLocationTwilio', locationId)
    if (action && action === 'setDefaultOutboundNumber') {
      await commit('resetPhoneNumbersPaginated', {
        page: null,
      })

      await dispatch('fetchPhoneNumbersFromDBPaginated', {
        companyId: state.company?.company?.id,
        locationId: locationId,
        getPaginatedDataOnly: false,
        payload: {
          limit: state.table?.limit,
          page: 1,
          query: '',
        },
      })
    } else {
      await dispatch('fetchPhoneNumbersFromDBPaginated', {
        companyId: state.company?.company?.id,
        locationId: locationId,
        getPaginatedDataOnly: false,
        payload: {
          limit: state.table?.limit,
          page: state.table?.currentPage,
          query: '',
        },
      })
    }

    return Promise.resolve(data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export default editPhoneNumber
